export type PromotionType =
  | 'none'
  | '1+1'
  | '2+1'
  | '3+1'
  | '4+1'
  | 'free_samples';

export interface PromoSplit {
  paid: number;
  free: number;
  delivered: number;
}

/**
 * Resolve the paid/free/delivered split for an order.
 * Mirrors `packages/backend/src/utils/promotion.ts`.
 */
export function computePromoSplit(
  quantity: number,
  promotion: PromotionType | string | undefined | null
): PromoSplit {
  const qty = Math.max(0, Math.floor(Number(quantity) || 0));

  if (!promotion || promotion === 'none') {
    return { paid: qty, free: 0, delivered: qty };
  }

  if (promotion === 'free_samples') {
    return { paid: 0, free: qty, delivered: qty };
  }

  const match = /^(\d+)\+1$/.exec(promotion);
  if (match) {
    const ratio = parseInt(match[1], 10);
    if (ratio > 0) {
      const free = Math.floor(qty / ratio);
      return { paid: qty, free, delivered: qty + free };
    }
  }

  return { paid: qty, free: 0, delivered: qty };
}

export function promotionLabel(promotion: PromotionType | string | undefined | null): string {
  if (!promotion || promotion === 'none') return 'No Promo';
  if (promotion === 'free_samples') return 'Free Samples';
  return `${promotion} Free`;
}
